<ion-header class="survey-header" [ngStyle]="{background: headerColor()}" no-border>
    @if(!isModal()){
        <div class="logo-wrapper">
            @if(logo()){
                <img [src]="logo()" alt="{{'Logo' | translate}}" />
            }
        </div>

        @if(languages()?.length > 1){
            <header-languages />
        }
    }
    @else {
        <ion-toolbar>
            @if(surveyName()?.[translate.currentLang]){
                <ion-title>{{ surveyName()[translate.currentLang] }}</ion-title>
            } @else {
                <ion-title>{{ 'Encuesta' | translate }}</ion-title>
            }
            <ion-buttons slot="end" (click)="dismissModal()">
                <ion-icon name="close"></ion-icon>
            </ion-buttons>
        </ion-toolbar>
    } 
</ion-header>